import { useState, useCallback } from "react";
import { ProfileForm } from "@/components/admin/ProfileForm";
import { AccountLinking } from "@/components/admin/AccountLinking";
import { GroupsList } from "@/components/admin/groups/GroupsList";
import { GroupScheduler } from "@/components/admin/groups/GroupScheduler";
import { GroupDetails } from "@/components/admin/groups/GroupDetails";
import type { AdminFormValues } from "@/utils/validation";
import type { Group } from "@/types/groups";

interface LinkedAccount {
  userId: string;
  fullName: string;
}

interface DashboardContentProps {
  profile: AdminFormValues | undefined;
  surveyResponses?: any[];
  currentUserId: string;
  linkedAccounts?: LinkedAccount[];
}

export const DashboardContent = ({ 
  profile, 
  surveyResponses, 
  currentUserId, 
  linkedAccounts 
}: DashboardContentProps) => {
  const [selectedGroup, setSelectedGroup] = useState<Group | null>(null);

  const handleSelectGroup = useCallback((group: Group | null) => {
    setSelectedGroup(group);
  }, []);

  const isLinkedGroup = selectedGroup && selectedGroup.group_leader_id !== currentUserId;
  const isScheduleAccepted = selectedGroup?.schedule_accepted_at;

  return (
    <div className="space-y-8">
      <ProfileForm initialData={profile} />
      
      <AccountLinking 
        currentUserId={currentUserId}
        linkedAccounts={linkedAccounts}
      />
      
      <GroupsList 
        selectedGroup={selectedGroup}
        onSelectGroup={handleSelectGroup} 
      />
      
      {selectedGroup && !isScheduleAccepted && !isLinkedGroup && (
        <GroupScheduler 
          group={selectedGroup}
          onClose={() => setSelectedGroup(null)}
        />
      )}
      
      {selectedGroup && (isScheduleAccepted || isLinkedGroup) && (
        <GroupDetails 
          group={selectedGroup}
          surveyResponses={surveyResponses}
        />
      )}
    </div>
  );
};
